import type { IJournal } from '../../../../common/validation/episodesAndJournal';
import type { ValidationErrors } from '../../../utils/validation';
import { JournalEntryType } from '../../../../common/enums/journalEntryType';
import { journalSchema } from '../../../../common/validation/episodesAndJournal';
import { validate } from '../../../utils/validation';

export function validateJournals(errors: ValidationErrors, journals?: IJournal[]) {
    if (journals) {
        for (const journal of journals) {
            if (journal) {
                const validationResult = validate(journalSchema, journal);

                Object.keys(journal).forEach((journalKey) => {
                    if (errors.has(journalKey)) {
                        errors = errors.remove(journalKey);
                    }
                });

                errors = errors.merge(validationResult.errors);
            }
        }
    }

    return errors;
}

export function checkJournalsHaveErrors(errors?: ValidationErrors): boolean {
    return !!errors?.some((value, key) => (key ? Object.keys(JournalEntryType).includes(key) : false));
}
